import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';

export default class Values extends Fragment {
  declare [Type]: 'dynamic-field/values';
}
